import React from 'react';

type ResultCardHighlightsProps = {
  highlights: string[];
}

// Renders the property card highlights so that the line breaks will happen between each string
export default function ResultCardHighlights({ highlights }: ResultCardHighlightsProps) {
  return (
    <>
      {highlights.map((text, i) => (
        <React.Fragment key={i}>
          <span className="d-inline-block text-break">{text}</span>
          {i < highlights.length - 1 && (<span> • </span>)}
        </React.Fragment>
      ))}
    </>
  );
}
